<template>
    <div>
      <h1>Course Details</h1>
      <p>Detailed information about the Affiliate Marketing Course.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AffiliateCourseDetails',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>